export interface OmniDUAContext {
  consumerAccountId?: string;
}

export const getValueFromContext = (omniContext: OmniDUAContext, key: string) => {
  // If this property is looking for a context value, attempt to populate it.
  if (!omniContext?.[key]) {
    console.error(`Could not find required context key: ${key}`);
    return undefined;
  }
  return omniContext?.[key];
};
